export default function getFlatMap(array = []) {
	return array.reduce((r, { children, ...rest }) =>
		r.concat({ ...rest }, getFlatMap(children)), []);
}
// export default function getFlatMap(array = []) {
// 	const result = [];
//
// 	for (let i = 0; i < array.length; i++) {
// 		const item = array[i];
//
// 		// Деструктурируем "children", а остальные поля оставляем в "rest"
// 		const { children, ...rest } = item;
//
// 		// Добавляем текущий элемент (без children) в результат
// 		result.push(rest);
//
// 		// Если есть дочерние элементы — рекурсивно обрабатываем их
// 		if (Array.isArray(children) && children.length > 0) {
// 			const childItems = getFlatMap(children);
// 			for (let j = 0; j < childItems.length; j++) {
// 				result.push(childItems[j]);
// 			}
// 		}
// 	}
//
// 	console.log('%c [  result  ] ', 'color:#bada55', typeof result, result );
// 	return result;
// }
